module.exports = __webpack_public_path__ + "static/media/jumbo_temp.482361d8.png";